import { useEffect, useRef } from 'react'

/**
 * Listens for the app-shell `billingUpdated` DOM event and fans it out to
 * whichever queries the Billing page is running. `skipBillingPage` is checked
 * via ref at dispatch time so MPBilling orgs (for which `billing(input:)`
 * errors on the backend) don't trigger that query.
 */
export const useBillingUpdatedListener = ({
  refetch,
  refetchBillingPage,
  skipBillingPage,
}: {
  refetch: () => void
  refetchBillingPage: () => void
  skipBillingPage: boolean
}): void => {
  const skipBillingPageRef = useRef(skipBillingPage)
  skipBillingPageRef.current = skipBillingPage

  useEffect(() => {
    const { ORGANIZATION_EVENT_KEY } = window?.appshell?.eventKeys || {}
    const { billingUpdated } = window?.appshell?.actionKeys || {}

    function handleBillingUpdate({
      detail,
    }: {
      detail: { action: string }
    }): void {
      if (detail.action === billingUpdated?.toString()) {
        void refetch()
        if (!skipBillingPageRef.current) void refetchBillingPage()
      }
    }

    window.addEventListener(ORGANIZATION_EVENT_KEY, handleBillingUpdate)

    return function cleanup(): void {
      window.removeEventListener(ORGANIZATION_EVENT_KEY, handleBillingUpdate)
    }
  }, [refetch, refetchBillingPage])
}
